import { createActorContext } from '@xstate/react';
import { chatbotMachine } from './chatbot.machine';

export const ChatbotContext = createActorContext(chatbotMachine, {
  id: 'chatbotState',
  systemId: 'chatbotState',
});

export * from './api';
export { chatbotMachine } from './chatbot.machine';
export { ChatbotButtonWrapper } from './ChatbotButtonWrapper';
export { ChatbotView } from './ChatbotView';
export * from './types';
